import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogClose, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { ActionButtonComponent } from '../action-button/action-button.component';

export interface ConfirmationModalData {
  title: string;
  subtitle?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

@Component({
  selector: 'app-confirmation-modal',
  imports: [ActionButtonComponent, MatIcon, MatDialogClose],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent {
  protected readonly data: ConfirmationModalData = inject(MAT_DIALOG_DATA);

  protected readonly confirmLabel = this.data.confirmLabel ?? 'Confirm';
  protected readonly cancelLabel = this.data.cancelLabel ?? 'Cancel';
}
